import React                        from 'react';
import PropTypes                    from 'prop-types';
import ReloadHelper                 from '../../../utils/ReloadHelper';
import Translations                 from '../../../utils/Translations';
import UrlBuilder                   from '../../../utils/UrlBuilder';
import DailybonusTodayOfferHeadLine from './DailybonusTodayOfferHeadLine';
import AgeRestrictionLabel          from '../SubComponents/AgeRestrictionLabel';
import AlbumPriceLabel              from '../SubComponents/AlbumPriceLabel';
import ContentLink                  from '../SubComponents/ContentLink';
import DailyBonusOfferBtn           from '../SubComponents/DailyBonusOfferBtn';
import FreeContentLabel             from '../SubComponents/FreeContentLabel';
import OfferIcon                    from '../SubComponents/OfferIcon';
import VipBadge                     from '../SubComponents/VipBadge';
import { formatEffectAsPlainText,
	    isCurrencyVoucher } from '../dailyBonusHelpers';
import Flux                 from '../../../flux/Flux.js';

class DailybonusTodayVideoOffer extends React.Component {

	constructor(props) {
        super(props);
		this.onClickHandler = this.onClickHandler.bind(this);
	}

	onClickHandler(e) {
		ReloadHelper.reload(e.currentTarget.href, e);
	}

	render() {
		const {
			      content,
			      conditions,
				  purchased,
				  offer,
			      effect,
			      quantity,
			      free,
			  }                = this.props;
		const {
			      preview,
			      ageRating,
				  price,
				  basePrice,
			      linkVX,
			      title,
			      duration,
			      model,
			      dailyBonusPrice,
			      hidden,
		      }                = content ? content : {};
		const previewPhoto     = preview ? preview.url : '/assets/img/placeholder.jpg';
		const contentAvailable = !hidden || purchased;
		const isVoucher        = isCurrencyVoucher(price);

		return (
			<div className='dailybonus-today-item'>
				<DailybonusTodayOfferHeadLine purchased={purchased} offer={offer} />
				<div className="dailybonus-today-item__wrapper">
					<div className="dailybonus-today-item__left-side" style={{backgroundImage: `url(${previewPhoto})`}}>
						<div className="dailybonus-today-item__left-side--budgeses">
							<AgeRestrictionLabel ageRating={ageRating} />
							{content && !free && (<AlbumPriceLabel price={price} basePrice={basePrice} discountedPrice={dailyBonusPrice} purchased={purchased} />)}
							<FreeContentLabel free={free} />
						</div>
						<div className="dailybonus-today-item__left-side--play">
							<ContentLink link={linkVX} enabled={contentAvailable}>
								<i className='icon -icon-play-rounded-line' />
							</ContentLink>
						</div>
						<div className="dailybonus-today-item__left-side--bottom-plate">
							<div className="dailybonus-today-item__left-side--bottom-plate__title">
								<ContentLink link={linkVX} enabled={contentAvailable}>
									{title}
								</ContentLink>
							</div>
							<div className="dailybonus-today-item__left-side--bottom-plate__detail">
								<span className='grey'>({duration}min)&nbsp;</span>
								{!!model && (
									<a onClick={this.onClickHandler} className='red'
									   href={UrlBuilder.buildActorProfileUrl(model.name)}
									>
										{model.name}
									</a>
								)}
							</div>
						</div>
					</div>
					<div className="dailybonus-today-item__right-side">
						<VipBadge conditions={conditions} />
						<div className="dailybonus-today-item__right-side__icon">
							<OfferIcon offer={offer} purchased={purchased} />
						</div>
						{purchased || free || isVoucher ? (
							<div className={'dailybonus-today-item__right-side__offer-no-effect' + (free || isVoucher ? ' -is-free' : '')}>
								{Translations.get('Video')}
							</div>
						) : (
							<div className="dailybonus-today-item__right-side__offer-effect">
								{formatEffectAsPlainText(effect)}
							</div>
						)}
						{purchased && (
							<div className='dailybonus-today-item__right-side__title-purchased'>
								{Translations.get(free ? 'successfullypurchased_free' : 'successfullypurchased')}
							</div>
						)}
						{isVoucher && !purchased && !free && (
							<div className="dailybonus-today-item__right-side__title -is-free">
								{price.currency.toUpperCase()} <br />
								{Translations.get('Redeem')}
							</div>
						)}
						{!isVoucher && !purchased && !free && (
							<div className="dailybonus-today-item__right-side__title">
								{Translations.get(effect.name === 'Discount' ? 'Discount365' : 'Bonus365')}
							</div>
						)}
						{!isVoucher && !purchased && free && (
							<div className="dailybonus-today-item__right-side__title -is-free">
								{Translations.get('DailyBonusFreeContentSubLine')}
							</div>
						)}
						{!isVoucher && !purchased && !free && Flux.Guest.isLoggedIn() && (
							<div className="dailybonus-today-item__right-side__description">
								{content && (
									<AlbumPriceLabel
										price={price}
										basePrice={basePrice}
										discountedPrice={dailyBonusPrice}
										additionalClass="--price-big"
										purchased={purchased}
									/>
								)}
							</div>
						)}
						<DailyBonusOfferBtn
							purchased={purchased}
							offer={offer}
							content={content}
							effect={effect}
							conditions={conditions}
							quantity={quantity}
							free={free}
							isCurrencyVoucher={isVoucher}
						/>
					</div>
				</div>
			</div>
		);
	}
}

DailybonusTodayVideoOffer.propTypes = {
	content:    PropTypes.object,
	conditions: PropTypes.array,
	offer:      PropTypes.string.isRequired,
	purchased:  PropTypes.bool,
	free:       PropTypes.bool,
	effect:     PropTypes.object,
	quantity:   PropTypes.number,
};

DailybonusTodayVideoOffer.defaultProps = {
	content:    {},
	conditions: [],
	purchased:  false,
	free:       false,
	effect:     {},
	quantity:   0,
};

export default DailybonusTodayVideoOffer;
